import { useEffectOnce } from 'react-use'

export default function useScrollToTop() {
  useEffectOnce(() => {
    setTimeout(() => window.scrollTo(0, 0), 10)
  })
}
